<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Area
        b-col(md="6")
          b-form-group(
            :label="$t('label.Area')",
            :label-for="$t('label.area')",
            description=""
          )
            validation-provider(:name="$t('label.area')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="area",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}

        // Area Leads
        b-col(md="6")
          b-form-group(
            :label="$t('label.areaLeads')",
            :label-for="$t('label.areaLeads')",
            description=""
          )
            v-select(
              v-model="data.areaLeads",
              :reduce="(areaLeads) => areaLeads.value",
              label="title",
              :multiple="true"
              :options="leads",
              :placeholder="$t('placeholder.responsible')"
            )

      // Button
      b-row
        b-col(
          cols="12"
          class="text-right"
        )
          b-button(
            variant="primary",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}
</template>

<script>
// eslint-disable-next-line import/extensions
import { ref, toRefs, onMounted } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import useCommon from '@/views/organization/useCommon'
import vSelect from 'vue-select'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect
  },

  props: ['data', 'isSubmitting'],

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const form = ref(null)
    const { getdepartmentLeadsForDropDown, leads } = useCommon()

    const validateArea = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateArea()
      .then(() => emit('submit', toRefs(props.data)))
      .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    onMounted(async () => {
      getdepartmentLeadsForDropDown()
    })

    return {
      required,
      form,
      validateAndSubmit,
      leads
    }
  },
}
</script>

<style scoped>

</style>
